import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'
import {
  titleize
} from "../../utils/utils";



const EbayLinkExplanatorModal = ({
  ebay
}) => {

  const [showEbayLinkExplanatorModal, setShowEbayLinkExplanatorModal] = useState(false);



  return <React.Fragment>
    <div className="mb-0">
      <p className="my-0 btn text-aiBlue text-weight-500 font-size-15px-imp explanator-link"
         onClick={() => setShowEbayLinkExplanatorModal(true)}
      >
        {titleize(I18n.t('js.indexSaleItems.ebayLink.whatIs').replaceAll(':sale_channel', ebay.meta_name))}
      </p>
    </div>


    {/*Modale che contiene il testo che spiega all'utente che cosa sia l'ebay link*/}
    <Modal animation={false} centered size="lg"
           show={showEbayLinkExplanatorModal}
           onHide={() => setShowEbayLinkExplanatorModal(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {I18n.t('js.indexSaleItems.ebayLink.whatIs').replace(':sale_channel', ebay.meta_name)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row d-flex align-items-center">
          <div className="col-12 col-sm-5 col-lg-4 d-flex justify-content-center pb-3">
            <img src={window.location.origin + `/images/aigrading-ebay-intersection.png`} alt=""/>
          </div>

          <div className="col-12 col-sm-7 col-lg-8 pb-0 pb-sm-2 pb-md-0">
            <p>
            {I18n.t('js.indexSaleItems.ebayLink.ebayLinkExplanation.p_1').replaceAll(':sale_channel', ebay.meta_name)}
            </p>
          </div>
        </div>

        {[2, 3, 4, 5, 6, 7].map(index => {
          const mainText = I18n.t(`js.indexSaleItems.ebayLink.ebayLinkExplanation.p_${index}`).replaceAll(':sale_channel', ebay.meta_name)
          return <div key={`paragraph_${index}`}>
            {
              [4, 5].includes(index) &&
              <p className="mt-3">
                <b>
                  {I18n.t(`js.indexSaleItems.ebayLink.ebayLinkExplanation.title_${index}`).replaceAll(':sale_channel', ebay.meta_name)}
                </b>
              </p>
            }
            <p>
              <span>{mainText.split('|')[0]}</span>
              <span className="text-underline-imp">{mainText.split('|')[1]}</span>
            </p>
            {
              [2].includes(index) &&
              <React.Fragment>
                  {
                    [1, 2, 3].map(i => {
                      return <p key={`paragraph_${index}_${i}`}>
                        <i className="fas fa-check text-aiBlue"/>&nbsp;
                        {I18n.t(`js.indexSaleItems.ebayLink.ebayLinkExplanation.p_${index}_point_${i}`).replaceAll(':sale_channel', ebay.meta_name)}
                      </p>
                    })
                  }
                </React.Fragment>
            }
          </div>
        })
        }
      </Modal.Body>
    </Modal>
  </React.Fragment>
};

export default EbayLinkExplanatorModal;